export default {
    "palette": {
        "primary": {
            "main": "#003367",
            "dark": "#082849"
        },
        "secondary": {
            "main": "#FFCC01"
        },
        "type": "dark"
    },
    "googleFonts": [
        "Open Sans:300,regular,500,600,700,800,300italic,italic,500italic,600italic,700italic,800italic"
    ],
    "typography": {
        "fontFamily": "Open Sans",
        "h6": {
            "fontWeight": 400
        },
        "body1": {
            "fontSize": "1.25rem"
        }
    }
};